module.exports = __webpack_public_path__ + "static/media/cladding-spraying.697bc072.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/optimised/cladding-spraying.jpg
// module id = 84
// module chunks = 0